import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ReducerPaths } from '../../constants/reducerPaths';
import { InternalFiltersState } from './internal-filters.types';

const initialState: InternalFiltersState = {
  Country: [],
};
export const internalFilters = createSlice({
  name: ReducerPaths.INTERNAL_FILTERS,
  reducers: {
    setSelectedCountryFilter: (state, action: PayloadAction<string[]>) => {
      state.Country = action.payload;
      return state;
    },
  },
  initialState,
});

export const { setSelectedCountryFilter } = internalFilters.actions;
